module.exports = __webpack_public_path__ + "img/noImage.16d91cae.webp";